var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"book",class:{ startBtn: _vm.bgc !== '#242B2A' },style:({ 'background-color': _vm.bgc }),on:{"click":function($event){_vm.submitShow = true}}},[_vm._v(" "+_vm._s(_vm.$t(`${_vm.text}`))+" ")]),(_vm.submitShow)?_c('mobilePublicConsultation',{on:{"close":function($event){_vm.submitShow = false}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }